import React from "react";
import {observer} from "mobx-react";
import {TimeSpan} from "@sparkware/app-utils";
import {SessionCooldownPopupBox} from "./boxes/session-cooldown.popup.box";
import {SessionCooldownPopupTextBox} from "./boxes/session-cooldown-popup-text.box";
import {SessionCooldownPopupTimerBox} from "./boxes/session-cooldown-popup-timer.box";
import {SessionCooldownPopupTimerRemainingBox} from "./boxes/session-cooldown-popup-timer-remaining.box";
import {CyClass} from "../../../common/cy-classes";
import {useServices} from "../../react-hooks/use-services.hook";

export interface ISessionCooldownPopupComponentProps {
  getRemainingTime: () => TimeSpan;
}

export const SessionCooldownPopupComponent: React.FC<ISessionCooldownPopupComponentProps> = observer((props) => {
    const services = useServices();
    const remainingTime = props.getRemainingTime();

    const prependZero = (value: number) => {
        return value.toString().padStart(2, '0');
    }

    return (
        <SessionCooldownPopupBox className={CyClass("cy-session-cooldown-popup")}>
            <SessionCooldownPopupTimerBox className={CyClass('cy-session-cooldown-remaining')}>
                {prependZero(remainingTime.minutes)}:{prependZero(remainingTime.seconds)}
            </SessionCooldownPopupTimerBox>
            <SessionCooldownPopupTimerRemainingBox>
                {services.translation.translate("SESSION_COOLDOWN_POPUP_REMAINING")}
            </SessionCooldownPopupTimerRemainingBox>
            <SessionCooldownPopupTextBox>
                {services.translation.translate("SESSION_COOLDOWN_POPUP_INFO_TEXT")}
            </SessionCooldownPopupTextBox>
        </SessionCooldownPopupBox>
    );

})
